var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.14726 11.375C6.14581 10.3373 6.34977 9.30949 6.74738 8.35094C7.14499 7.39239 7.72839 6.52202 8.46394 5.78999C9.1995 5.05797 10.0727 4.47877 11.0331 4.08577C11.9936 3.69278 13.0223 3.49377 14.06 3.50021C18.3901 3.5324 21.8537 7.13161 21.8537 11.4739V12.25C21.8537 16.1673 22.6733 18.4405 23.3951 19.6829C23.4729 19.8157 23.5143 19.9666 23.5151 20.1204C23.5159 20.2743 23.4761 20.4256 23.3998 20.5592C23.3235 20.6928 23.2133 20.8039 23.0803 20.8813C22.9473 20.9586 22.7963 20.9996 22.6425 21H5.35763C5.20377 20.9996 5.05272 20.9586 4.91974 20.8812C4.78676 20.8038 4.67655 20.6927 4.60022 20.5591C4.52389 20.4255 4.48415 20.2741 4.485 20.1203C4.48585 19.9664 4.52726 19.8155 4.60506 19.6827C5.3273 18.4403 6.14725 16.1671 6.14725 12.25L6.14726 11.375Z",
    stroke: "#3082F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21V21.875C10.5 22.8033 10.8687 23.6935 11.5251 24.3499C12.1815 25.0063 13.0717 25.375 14 25.375C14.9283 25.375 15.8185 25.0063 16.4749 24.3499C17.1313 23.6935 17.5 22.8033 17.5 21.875V21",
    stroke: "#3082F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.3701692634781abe35ae5025fb8824ac.svg";
export { ForwardRef as ReactComponent };